
import React from 'react';

const WebtaskSVG = () =>
  <svg height="150px" width="150px" version="1.1" viewBox="0 0 150 150">
    <g fill="none" stroke="none" strokeWidth="1">
      <path d="M150,150 L0,150 L0,0 L150,0 L150,150 Z" fill="#5F3237"/>
      <path d="M150,150 L30,150 L30,30 L150,30 L150,150 Z" fill="#E56E62"/>
      <path d="M120,120 L30,120 L30,30 L120,30 L120,120 Z" fill="#ED955B"/>
      <path d="M120,120 L60,120 L60,60 L120,60 L120,120 Z" fill="#F9E862"/>
      <path d="M90,90 L60,90 L60,60 L90,60 L90,90 Z" fill="#FFFFFF"/>
    </g>
  </svg>;

export default WebtaskSVG;


// WEBPACK FOOTER //
// ./src/svg/WebtaskSVG.js